/**
 * @generated SignedSource<<9afb1d1b74f1d2df910d94d277e2cbe7>>
 * @relayHash 9b9ea3fac36d51f9dc2434fdff990505
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9b9ea3fac36d51f9dc2434fdff990505

import { ConcreteRequest } from 'relay-runtime';
export type chHasMedicationSuggestionForDiagnosisCodeQuery$variables = {
  diagnosisCode: string;
};
export type chHasMedicationSuggestionForDiagnosisCodeQuery$data = {
  readonly ch_hasMedicationSuggestionForDiagnosisCode: boolean;
};
export type chHasMedicationSuggestionForDiagnosisCodeQuery = {
  response: chHasMedicationSuggestionForDiagnosisCodeQuery$data;
  variables: chHasMedicationSuggestionForDiagnosisCodeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "diagnosisCode"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "diagnosisCode",
        "variableName": "diagnosisCode"
      }
    ],
    "kind": "ScalarField",
    "name": "ch_hasMedicationSuggestionForDiagnosisCode",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "chHasMedicationSuggestionForDiagnosisCodeQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "chHasMedicationSuggestionForDiagnosisCodeQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "9b9ea3fac36d51f9dc2434fdff990505",
    "metadata": {},
    "name": "chHasMedicationSuggestionForDiagnosisCodeQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f00d2e2c299aca3f80c4f4f60b8c86dd";

export default node;
